import React from 'react'
import { Container } from '@kogk/common'

const RichText = ({ html }: { html: string }) => (
  <Container className='page-slice-spacer'>
    <div dangerouslySetInnerHTML={{ __html: html }} className='article col-lg-8 offset-lg-2 p-0' />
  </Container>
)

export default RichText
